import React from "react";
import resumeFile from "../documents/Justin_Grant_Resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2000 - 2003",
      title: "Computer Engineering",
      place: "San Diego State University",
      desc: "",
    },
    {
      yearRange: "1997 - 1999",
      title: "Lower Division GE",
      place: "Palomar College",
      desc: "Focus on math and language in line for Computer Engineering goals.",
    },
  ];

  const certificationDetails = [
    {
      yearRange: "April 2023",
      title: "Automation Pro I  #t3g3yh3o9k2j",
      place: "Workato",
      desc: "Recipe building, trigger conditions, data mapping, formulas and recipe jobs.",
    },
    {
      yearRange: "April 2023",
      title: "Automation Pro II  #n4ush49285ei",
      place: "Workato",
      desc: "Conditional actions, repeat actions, variables and lookup tables.",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2025 - Present",
      title: "Epicor Developer",
      place: "Goodway Technologies",
      desc: "Epicor Kinetic integration and e-commerce engineering. OAuth 2.0 JWT bearer flow (RFC 7523) with RS256 signing between a Drupal storefront and Salesforce; automated order capture from storefront into Kinetic with an idempotency ledger so retries can never duplicate an order; self-service campaign analysis tooling for the sales organization; version control for Kinetic customization layer JSON; migration support from Epicor 10 on-prem to Kinetic Cloud multi-tenant. Docker containers for development and integration environments.",
    },
    {
      yearRange: "2024 - 2025",
      title: "Epicor Programmer",
      place: "Stevens Industries",
      desc: "Supported the ERP migration at a configure-to-order cabinet manufacturer. Re-platformed the company's core manufacturing and engineering tools — built over years against Microvellum — to operate through Epicor instead, preserving established production workflow. Built an automated Engineering Workbench creation system driven by job progress, generating engineering methods as a job advanced rather than requiring manual setup on every configured order. Automated customer-facing reporting and correspondence from live job and order data.",
    },
    {
      yearRange: "2022 - 2024",
      title: "Software Engineer",
      place: "Comtec Solutions",
      desc: "Epicor consultancy serving manufacturing and distribution clients across Epicor 9, 10 and Kinetic. Epicor 9 integrations against both Progress and SQL Server. Automated operations and materials management for a high-profile German manufacturing client, including REST API optimization for high-volume throughput. Automated SSRS distribution and external payroll processing. Complex Kinetic Application Studio customizations, including diagnosing and mitigating breakages introduced by Epicor platform updates and handling conversions across version upgrades. Workato Automation Pro certified.",
    },
    {
      yearRange: "2017 - 2022",
      title: "Principal Developer",
      place: "Sure Foundation Solutions",
      desc: "Lead developer through the full lifecycle of several applications. Document and attachment management with automated invoice attachment, fixed-position and PDF parsing, and archival into Google Drive. Distribution queue software with automated pallet assignment based on part dimensions and integrated label printing. Device-agnostic receiving application tying shipments to purchase orders with image attachment, extended with a field quality-assurance tool capturing photographic evidence against the originating transaction. Windows service development for printer device management. Deep Epicor BO tracing to build integrations against undocumented behavior.",
    },
    {
      yearRange: "2015 - 2017",
      title: "Senior Software Developer",
      place: "Slacker Radio, Inc.",
      desc: "Lead developer on the Sony TV hosted interface through its full lifecycle, including the CSS3-animated presentation layer. Lead developer on the e-commerce interface for customer subscriptions. Lead support on markup design across the core of Slacker.com. Containerized development environments with Docker. JavaScript, Java (Maven/Ant), Knockout.js.",
    },
    {
      yearRange: "2013 - 2015",
      title: "Software Engineer",
      place: "Blackbaud",
      desc: "C# .NET MVC development and organizational unit programming. Internal web tools for network discovery and reporting across a global network, focused on workstations acquired through company mergers. Console applications to discover newly acquired machines on newly added networks and surface DNS groups not captured in ADDM.",
    },
    {
      yearRange: "2009 - 2013",
      title: "Senior Web Developer",
      place: "Digitaria / NBC",
      desc: "Primary developer on the original The Voice website — interactive voting, online auditions and games — plus voting tools for America's Got Talent, and work on The Office, Days of Our Lives and Minute To Win It. Designed modular templates and slideshow components adopted across roughly 90% of NBC show sites. JavaScript, CSS3, jQuery, Tween.js, Bootstrap, Rails.",
    },
  ];

  const skillGroups = [
    {
      name: "ERP / Epicor",
      desc: "Epicor 9, 10, Kinetic · On-prem and SaaS (dedicated & multi-tenant) · BPMs · BAQs · Kinetic Functions · Application Studio · Customization layers · BO tracing to C# API methods · SSRS & Crystal",
    },
    {
      name: "Integration & Backend",
      desc: "C# · .NET · REST service design & consumption · OAuth 2.0 / JWT · Entity Framework · LINQ / LINQ to SQL · SQL & stored procedures · MongoDB · Docker · File parsing and generation (PDF, Excel, CSV, fixed-width, XML, JSON)",
    },
    {
      name: "Front-End & Web",
      desc: "JavaScript · React · Angular · Node.js · HTML5 · CSS3 · SASS · ASP.NET MVC · Knockout.js · Responsive web applications · Custom portals and interfaces · PHP",
    },
    {
      name: "Platforms",
      desc: "Salesforce (Apex, Experience Cloud, Agentforce) · Drupal 10 / Commerce 3 · Microvellum · Google Drive · BarTender · Scanner, RFID and USB device integration",
    },
    {
      name: "Data & Analysis",
      desc: "Large-dataset analysis and reporting · Syndicated media data (Nielsen) · Campaign performance analysis · Custom analytics tooling",
    },
    {
      name: "Automation",
      desc: "Epicor scheduled processes and System Agent configuration · Automated functions and BAQ processes · Windows services and task scheduling · Workato",
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of my resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          <div className="col-lg-6 wow fadeInUp">
            {/* My Experience */}
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            {/* My Education */}
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>

            {/* My Certification */}
            <h2 className="text-7 fw-600 mb-4 pb-2">My Certification</h2>
            <div className="border-start border-2 border-primary ps-3">
              {certificationDetails.length > 0 &&
                certificationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="row gx-5 gy-4">
          {skillGroups.length > 0 &&
            skillGroups.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-600 text-dark mb-1 border-bottom border-2 border-primary d-inline-block">
                  {skill.name}
                </p>
                <p className="text-muted mb-0">{skill.desc}</p>
              </div>
            ))}
        </div>
        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download Resume
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
